<script>
import FormsDiscountsBaseSave from '@/components/forms/discounts/FormsDiscountsBaseSave'
export default {
  extends: FormsDiscountsBaseSave,

  props: {
    receiptProductObject: {
      type: Object,
      required: true
    }
  },

  data: () => ({
    entityUuid: null,
    receiptProduct: null
  }),

  watch: {
    receiptProductObject: {
      immediate: true,
      handler (receiptProductObject) {
        this.receiptProduct = Object.assign({}, receiptProductObject)
        this.entityUuid = receiptProductObject.uuid
        if (this.receiptProduct.discountForStaff) {
          this.discountForStaff = true
          this.form.chosenDiscountType = null
          this.form.chosenDiscountValue = null
        } else {
          if (this.form.chosenDiscountType) {
            this.form.chosenDiscountType = receiptProductObject.discountType
          }
          if (this.form.chosenDiscountValue) {
            this.form.chosenDiscountValue = receiptProductObject.discountValue
          }
        }
      }
    }
  },

  methods: {
    addStaffDiscount (receiptProductUuid) {
      this.$wait.start('saving discount')
      return this.$store.dispatch('RECEIPT/ADD_ROW_DISCOUNT_STAFF', { receiptProductUuid: this.receiptProduct.uuid })
        .then((data) => {
          this.helpers.toastSuccess(data.message)
          this.$emit('saved', data)
        })
        .catch(data => { if (data && data.message) this.helpers.toastError(data.message) })
        .finally((data) => this.$wait.end('saving discount'))
    },
    removeDiscount (receiptProductUuid) {
      this.$wait.start('saving discount')
      return this.$store.dispatch('RECEIPT/REMOVE_ROW_DISCOUNT', { receiptProductUuid })
        .then((data) => {
          this.helpers.toastSuccess(data.message)
          this.form.chosenDiscountType = this.form.chosenDiscountValue = null
          this.$emit('saved', data)
        })
        .catch(data => { if (data && data.message) this.helpers.toastError(data.message) })
        .finally(() => {
          this.$wait.end('saving discount')
        })
    },
    submit () {
      if (!this.validate()) return
      this.$wait.start('saving discount')
      return this.$store.dispatch('RECEIPT/ADD_ROW_DISCOUNT', {
        receiptProductUuid: this.receiptProduct.uuid,
        discountType: this.form.chosenDiscountType,
        discountValue: this.form.chosenDiscountValue
      })
        .then((data) => {
          this.helpers.toastSuccess(data.message)
          this.$emit('saved', data)
        })
        .catch(data => { if (data && data.message) this.helpers.toastError(data.message) })
        .finally((data) => this.$wait.end('saving discount'))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/forms/discounts/FormsDiscountsReceiptProductSave.vue